export default {
  addLanguage: 'Agregar idioma'
}

export const en = {
  addLanguage: 'Add language'
}

export const ca = {
  addLanguage: 'Afegir idioma'
}
